import { Steps as AntdSteps } from 'antd';

import { usePublicCalculatorContext } from '~src/context/PublicCalculatorContext';

import { dividerStyle, StepAnchor, StyledChevron } from './style';
import { StepsProps } from './types';
import { getStepStatus } from './util';

const { Step } = AntdSteps;

export const Steps = ({
  direction = 'vertical',
  lastStepButtonText = 'afslut',
  showChevron,
  showDivider,
  CustomIcon,
  NavigationButtons,
  onFinish,
  steps,
  ...rest
}: StepsProps) => {
  const {
    visitedStageMap,
    setVisitedStageMap,
    showResidenceInputFields,
    setShowResidenceInputFields,
    stage,
    setStage,
  } = usePublicCalculatorContext();

  return (
    <AntdSteps {...{ direction, current: stage, ...rest }}>
      {steps.map((step, index) => {
        const { content, completed, key, title = `Trin ${index + 1}`, ...props } = step;
        const isCurrentStep = stage === index;
        const lastStepIndex = steps.length - 1;

        const isCompleted = !!completed && (visitedStageMap[index + 1] ?? false);

        const status = getStepStatus(isCompleted, isCurrentStep);

        const stepStyle =
          showDivider && index !== lastStepIndex ? { ...props.style, ...dividerStyle } : { ...props.style };

        // Warning:
        // Be aware that AntD will replace any non <Step/> children with unwanted default icon steps
        // Do not return a fragment or array with multiple components here. Only a single <Step/>.
        return (
          <Step
            key={key}
            {...{
              ...props,
              onClick: () => setStage(index),
              title: (
                <div>
                  {!CustomIcon && <div {...{ style: { fontWeight: isCurrentStep ? 'bold' : undefined } }}>{title}</div>}
                </div>
              ),
              status,
              ...(CustomIcon && {
                icon: (
                  <CustomIcon
                    {...{
                      index,
                      status,
                      title,
                      chevron: showChevron ? (
                        <StyledChevron
                          {...{
                            open: status === 'process',
                          }}
                        />
                      ) : undefined,
                    }}
                  />
                ),
              }),
              description: isCurrentStep && (
                <div
                  {...{
                    ...(showDivider && {
                      style: {
                        paddingBottom: isCurrentStep ? '80px' : title ? undefined : '32px',
                        marginBottom: '8px',
                      },
                    }),
                  }}
                >
                  <StepAnchor {...{ id: `Step-${key}` }} />
                  {content}
                  {!!NavigationButtons && (
                    <NavigationButtons
                      {...{
                        stepKeys: steps.map(({ key: stepKey }) => `Step-${stepKey}`),
                        stage,
                        setStage: newStage => {
                          setStage(newStage);
                          setVisitedStageMap?.(newStage);
                        },
                        lastStepIndex,
                        enabled: completed,
                        onFinish,
                        lastStepButtonText,
                        showResidenceInputFields,
                        setShowResidenceInputFields,
                      }}
                    />
                  )}
                </div>
              ),
              style: stepStyle,
            }}
          />
        );
      })}
    </AntdSteps>
  );
};
